module.exports = __webpack_public_path__ + "img/coin_prices_charts.2c6bf82d.png";